module.exports = __webpack_public_path__ + "img/YC06@2x.c4139483.png";